export default __webpack_public_path__ + "static/media/1923.dd746847.png";